import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'productsFamily',
  defaults: []
})
@Injectable()
export class ProductsFamilyState {

  private static service: DropdownService

  static hasAny() {
    return createSelector([ProductsFamilyState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  static getNameById(id: number) {
    return createSelector([ProductsFamilyState], (state: IdNamePair[]) => {
      return state.find((item: IdNamePair) => item.id === id).value;
    });
  }

  constructor(injector: Injector) {
    ProductsFamilyState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<ProductsFamilyState>) {
    this.service.getDropdownDataByPost(ENDPOINTS.getProductsFamilyList()).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

}
